'use strict';

module.exports = /*@ngInject*/
function(
    ApiConfig,
    InterceptorService
) {
    return {
        getRootCats: function(siteId) {
            return InterceptorService.cachedGet(ApiConfig.rootCats + '/' + siteId);
        }
    };
};
